/* eslint-disable no-undef */
// userSaga.js
import { call,  put,  takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { Modal } from 'antd';
import { FORGOT_PASSWORD_REQUEST } from './Constants';
import {forgotPasswordpageRedirect, forgotPasswordRequestError, forgotPasswordRequestSuccess} from './Actions';
// import { Modal } from 'antd';


function* forgotPassword(action) {

    try {    

        const url = `${process.env.REACT_APP_API_BASE_URL}/authManagement`;

        const headers ={
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        

        let data = {
            action: 'sendResetPwd',
            value: { email: action.payload.userName },
        };        
        
        const response = yield call(axios.post, url, data, { headers});
        
        if(response.status === 200 || response.status === 201) {

            Modal.success({
                title: 'Success!',
                content: 'Please check your email to reset password',
            });
            yield put(forgotPasswordRequestSuccess(response.data));
            yield put(forgotPasswordpageRedirect('/login'));

        } else {

            yield put(forgotPasswordRequestError('An error occurred.'));
            yield put(forgotPasswordpageRedirect('/login'));
            
        }
                       
    } catch (error) {        
        console.log('error', error);
        if(error.status === 406) {
            Modal.warning({
                title: 'Verification Required',
                content: 'Your security is our top priority. To reset your password, please verify your account using the link sent to your email. Once verified, you\'ll be able to set a new password',
            });    
        } else {
            Modal.error({
                title: 'Reset Failed',
                content: 'Your email is not associated with QuikDr Network, Please do the signup!',
            });  
        }
        
            
        yield put(forgotPasswordpageRedirect('/login'));
        yield put(forgotPasswordRequestError('An error occurred.'));
    }

}

// Watcher Saga
export function* watchFetchForgotPassword() {
    yield takeEvery(FORGOT_PASSWORD_REQUEST, forgotPassword);

}
